import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import AdminApi from '../../../../store/services/admin';
import { StudentActions } from '../../../../store/StudentAction';
import { getEvents } from '../../../../store/adminActions';
import { useAppDispatch } from '../../../../store/hooks/hooks';
import { useNavigate } from 'react-router-dom';
import { MenuItem } from '@mui/material';
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';

export default function DeleteDialog(props:any) {
    const [open, setOpen] = React.useState(false);
    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };


    const deleteEvent = () => {
        AdminApi.deleteEventRequest({ id: props.event._id }).then(async (res: any) => {
            handleClose()
            dispatch(StudentActions.setMessage("Meeting Deleted"))
            await dispatch(getEvents("all"))
        }).catch((e) => {
            handleClose()
            if (e.response.status === 403) {
                navigate('/login')
            }
            dispatch(StudentActions.setMessage("Deletion of Event Failed.Try again."))
        })
    }

    return (
        <div>
            <MenuItem onClick={() => {
                handleClickOpen()
            }} disableRipple>
                <DeleteForeverRoundedIcon fontSize='small' className='m-2' />
                Delete
            </MenuItem>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Delete Event
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete the selected event?.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} autoFocus>No</Button>
                    <Button onClick={deleteEvent} variant="contained" >
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}